
export default class API {
  static req(url, options) {
    return fetch(url, options).then(r => r.json())
  }


  static getCart() {
    return this.req(`https://${window.location.host}/cart.json`).catch(e => console.error('Cant fetch cart', e));
  }

  static updateCart(updates) {
    return this.req(`https://${window.location.host}/cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    }).catch(e => console.error('Cant update cart', e))
  }

  static setStorage(existingCodes) {
    return localStorage.setItem('promopuma', JSON.stringify(existingCodes));
  }

  static getStorage() {
    return JSON.parse(localStorage.getItem('promopuma'));
  }

  // static getCookie() {
  //   let cookie = undefined;
  //   try {
  //     cookie = document.cookie.match(/promo_puma_codes=(.*?);/)?.[1];
  //     if (cookie) {
  //       cookie = JSON.parse(decodeURI(cookie));
  //     }
  //   } catch (e) {
  //     console.error('cookie issue', cookie)
  //     cookie = undefined;
  //   }
  //   return cookie;
  // }

  // static setCookie(existingCodes) {
  //   const date = new Date();
  //   date.setDate(date.getDate() + 3);
  //   document.cookie = `promo_puma_codes=${encodeURI(JSON.stringify(existingCodes))}; expires=${date.toUTCString()}; path=/`;
  // }
}


